const currencySymbol = (currency) => {
    const normalizedCurrency = String(currency || "").trim().toUpperCase();

    switch (normalizedCurrency) {
        case "PLN":
            return "zł";
        case "EUR":
            return "€";
        case "USD":
            return "$";
        default:
            return "zł";
    }
};

export default currencySymbol;
